import { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { Fingerprint } from "@mui/icons-material";
import EKYCModal from "./EKYCModal";
import TwoFAModal from "./TwoFAModal";
import { AnimatePresence, motion } from "framer-motion";

const BiometricSection = ({ ekycStatus, banks, location, twoFAStatus, showMobileOtp }) => {
  const [openEKYC, setOpenEKYC] = useState(false);
  const [openTwoFA, setOpenTwoFA] = useState(false);

  console.log(ekycStatus);
  console.log(twoFAStatus);
  console.log(showMobileOtp);
  const buttonStyle = {
    borderRadius: "8px",
    fontWeight: "bold",
    backgroundColor: "#d32f2f",
    "&:hover": {
      backgroundColor: "#b71c1c",
      boxShadow: "0 5px 15px rgba(183,28,28,0.4)",
    },
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "20px",
          marginTop: "2%",
        }}
      >
        {ekycStatus === "FALSE" && (
          <>
            <AnimatePresence>
              <motion.div
                whileHover={{ scale: 1.1 }}
                transition={{ type: "spring", stiffness: 200 }}
              >
                <Button
                  variant="contained"
                  color="secondary"
                  size="large"
                  startIcon={<Fingerprint />}
                  sx={buttonStyle}
                  onClick={() => setOpenEKYC(true)}
                >
                  Verify eKYC
                </Button>
              </motion.div>
            </AnimatePresence>

            <Typography variant="body1" color="textSecondary" align="center">
              Please complete eKYC verification before proceeding to Two Factor Authentication.
            </Typography>

            <EKYCModal
              open={openEKYC}
              onClose={() => setOpenEKYC(false)}
              banks={banks}
              location={location}
            />
          </>
        )}

        <AnimatePresence>
          <motion.div
            whileHover={{ scale: 1.1 }}
            transition={{ type: "spring", stiffness: 200 }}
          >
            <Button
              variant="contained"
              color="secondary"
              size="large"
              startIcon={<Fingerprint />}
              sx={buttonStyle}
              onClick={() => setOpenTwoFA(true)}
              disabled={ekycStatus === "FALSE"} // Disable until eKYC is complete
            >
              Verify Two FA
            </Button>
          </motion.div>
        </AnimatePresence>

        <TwoFAModal
          open={openTwoFA}
          onClose={() => setOpenTwoFA(false)}
          banks={banks}
          location={location}
        />
      </Box>

    </>
  );
};

export default BiometricSection;
